import { authorizedAction } from 'api'
import { ErrorProp } from './'

export type ResendLMSSignatureRequestResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type ResendLMSSignatureRequestProps = {
  userId?: string
}

export async function resendLMSSignatureRequest({
  userId,
}: ResendLMSSignatureRequestProps): Promise<ResendLMSSignatureRequestResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Teacher.LMSResendLegal',
      body: {
        Username: userId,
        courseType: 'appTeacherTraining',
      },
    })

    const json = (await response.json()) as ResendLMSSignatureRequestResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
